/* Gloss v4 "Wet Light" (test theme): one rAF scroll loop, no libraries.
   Cold-open nail window · lateral dolly · 7-Free strikes · drift · film timecode · three-stroke reveals ·
   lazy-play videos · call-sheet tabs · drop cursor. Reduced motion (html.wl-rm): no pinning/autoplay. */
(function(){
  'use strict';
  var d=document, root=d.documentElement, RM=root.classList.contains('wl-rm');
  var clamp=function(v,a,b){return Math.max(a,Math.min(b,v))};
  var ease=function(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2};
  var phone=function(){return innerWidth<=760};
  var $=function(s,c){return (c||d).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))};

  /* headline words */
  $$('.wl-words').forEach(function(h){
    var i=0;(function walk(node){Array.prototype.slice.call(node.childNodes).forEach(function(n){
      if(n.nodeType===3){var f=d.createDocumentFragment();n.textContent.split(/(\s+)/).forEach(function(p){if(!p)return;if(/^\s+$/.test(p)){f.appendChild(d.createTextNode(p));return}var s=d.createElement('span');s.className='w';s.style.setProperty('--i',i++);s.textContent=p;f.appendChild(s)});node.replaceChild(f,n)}
      else if(n.nodeType===1&&!n.classList.contains('w'))walk(n)})})(h);
  });
  /* inner pages: arch images get the three-stroke reveal */
  $$('.g-phero .g-arch').forEach(function(el){el.classList.add('wl-stroke');el.setAttribute('data-wl-reveal','')});

  /* cold-open video: one cut per screen */
  var hv=$('.wl-hero-video'), tog=$('[data-wl-play]');
  if(hv){
    var k=phone()?'m':'d';
    hv.poster=hv.getAttribute('data-'+k+'-poster');
    [['webm','video/webm'],['mp4','video/mp4']].forEach(function(f){var s=d.createElement('source');s.src=hv.getAttribute('data-'+k+'-'+f[0]);s.type=f[1];hv.appendChild(s)});
    hv.load();
    var sync=function(){if(tog){tog.setAttribute('aria-pressed',String(!hv.paused));tog.textContent=hv.paused?'Play film':'Pause film'}};
    if(!RM){hv.autoplay=true;var pp=hv.play();if(pp&&pp.catch)pp.catch(function(){})}
    hv.addEventListener('play',sync);hv.addEventListener('pause',sync);sync();
    if(tog)tog.addEventListener('click',function(){hv.paused?hv.play():hv.pause()});
  }

  /* lazy films + reveals */
  if('IntersectionObserver' in window){
    var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
      if(e.isIntersecting){if(v.preload==='none'){v.preload='auto';v.load()}if(!RM){var p=v.play();if(p&&p.catch)p.catch(function(){})}}else v.pause()})},{rootMargin:'200px 0px'});
    $$('video[data-wl-lazy]').forEach(function(v){vio.observe(v)});
    if(hv){new IntersectionObserver(function(es){es.forEach(function(e){if(RM||!hv.autoplay)return;e.isIntersecting?hv.play().catch(function(){}):hv.pause()})}).observe(hv.closest('.wl-cold'))}
    var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target)}})},{threshold:.15});
    $$('[data-wl-reveal],.wl-words').forEach(function(el){RM?el.classList.add('in'):rio.observe(el)});
  } else $$('[data-wl-reveal],.wl-words').forEach(function(el){el.classList.add('in')});

  /* call-sheet tabs */
  $$('[data-wl-tabs]').forEach(function(w){
    var tabs=$$('[role=tab]',w), pans=$$('[role=tabpanel]',w);
    function sel(i){tabs.forEach(function(t,j){t.setAttribute('aria-selected',j===i?'true':'false');t.tabIndex=j===i?0:-1});pans.forEach(function(p,j){p.hidden=j!==i})}
    tabs.forEach(function(t,i){t.addEventListener('click',function(){sel(i)});t.addEventListener('keydown',function(e){
      var n=i;if(/Arrow(Right|Down)/.test(e.key))n=(i+1)%tabs.length;else if(/Arrow(Left|Up)/.test(e.key))n=(i-1+tabs.length)%tabs.length;else return;e.preventDefault();sel(n);tabs[n].focus()})});
  });

  /* scroll choreography + timecode */
  var cold=$('.wl-cold'), dollyS=$('.wl-ritual'), dolly=$('.wl-dolly'), seven=$('.wl-seven');
  var rits=dolly?$$('.wl-rit',dolly):[], lis=seven?$$('.wl-seven__list li',seven):[], cnt=$('[data-wl-count]'), ff=$('[data-wl-ff]');
  var drifts=$$('[data-wl-drift]'), acts=$$('[data-wl-act]');
  var tc=$('[data-wl-tc]'), tcAct=$('[data-wl-tc-act]'), tcTime=$('[data-wl-tc-time]');
  if(tc&&tcAct&&tc.getAttribute('data-scene'))tcAct.textContent=tc.getAttribute('data-scene');
  var ticking=false, vh=innerHeight;
  function prog(el){var r=el.getBoundingClientRect();return clamp(-r.top/Math.max(1,r.height-vh),0,1)}
  function pad(n){return(n<10?'0':'')+n}
  function frame(){
    ticking=false;vh=innerHeight;
    var y=scrollY, H=root.scrollHeight-vh;
    var lim=(cold&&!phone())?Math.max(24,cold.offsetHeight-vh*1.05):24;d.body.classList.toggle('g-scrolled',y>lim);
    if(tcTime){var s=clamp(y/Math.max(1,H),0,1)*180;tcTime.textContent='00:'+pad(Math.floor(s/60))+':'+pad(Math.floor(s%60))+':'+pad(Math.floor((s%1)*24))}
    if(tcAct&&acts.length){var lab=tc.getAttribute('data-scene');for(var i=acts.length-1;i>=0;i--){if(acts[i].getBoundingClientRect().top<vh*.5){lab=acts[i].getAttribute('data-wl-act');break}}if(tcAct.textContent!==lab)tcAct.textContent=lab}
    if(RM)return;
    var ph=phone();
    if(cold){var p=prog(cold),e=ease(clamp(p/.75,0,1)),x0=ph?.2:.37,y0=ph?.17:.14;
      cold.style.setProperty('--p',p.toFixed(4));
      cold.style.setProperty('--ai-x',((1-e)*x0*100).toFixed(3)+'vw');
      cold.style.setProperty('--ai-y',((1-e)*y0*100).toFixed(3)+'vh');
      cold.style.setProperty('--ar',(e<.98?(1-e)*(ph?400:600):0).toFixed(1)+'px');
      cold.style.setProperty('--lb',(1-clamp(p*1.4,0,1)).toFixed(3));}
    if(dollyS&&dolly&&!ph){var p2=prog(dollyS),span=Math.max(0,dolly.scrollWidth-innerWidth);
      dolly.style.setProperty('--dx',(ease(p2)*span).toFixed(1));dollyS.style.setProperty('--p',p2.toFixed(4));
      rits.forEach(function(r,i){r.style.setProperty('--sheen',clamp(p2*1.6-i*.16,0,1).toFixed(3))});}
    if(seven&&lis.length){var p3=prog(seven),n=Math.floor(clamp((p3-.08)/.7,0,1)*(lis.length+.999));n=Math.min(n,lis.length);
      lis.forEach(function(li,i){li.classList.toggle('out',i<n)});if(cnt)cnt.textContent=String(lis.length-n);
      if(ff)ff.style.setProperty('--ff',clamp((p3-.78)/.15,0,1).toFixed(3));}
    drifts.forEach(function(el){var r=el.getBoundingClientRect();if(r.bottom<-200||r.top>vh+200)return;var host=el.closest('.wl-epi')||el;host.style.setProperty('--py',clamp((vh-r.top)/(vh+r.height),0,1).toFixed(3))});
  }
  function req(){if(!ticking){ticking=true;requestAnimationFrame(frame)}}
  addEventListener('scroll',req,{passive:true});addEventListener('resize',req);
  if(dolly){var rb=$('.wl-rail b');dolly.addEventListener('scroll',function(){var m=dolly.scrollWidth-dolly.clientWidth;if(rb)rb.style.setProperty('--hx',m>0?(dolly.scrollLeft/m).toFixed(3):0)},{passive:true})}
  if(RM&&lis.length&&cnt)cnt.textContent='0';
  frame();

  /* drop cursor (homepage, fine pointers) */
  if(!RM&&cold&&matchMedia('(hover:hover) and (pointer:fine)').matches){
    var dr=d.createElement('div');dr.className='wl-drop';dr.setAttribute('aria-hidden','true');dr.innerHTML='<span>Book</span>';d.body.appendChild(dr);
    var tx=0,ty=0,cx=0,cy=0,on=false;
    addEventListener('pointermove',function(e){tx=e.clientX;ty=e.clientY;if(!on){on=true;cx=tx;cy=ty;dr.classList.add('on');loop()}},{passive:true});
    d.documentElement.addEventListener('pointerleave',function(){dr.classList.remove('on')});
    $$('[data-wl-drop],[data-book]').forEach(function(a){a.addEventListener('pointerenter',function(){dr.classList.add('big')});a.addEventListener('pointerleave',function(){dr.classList.remove('big')})});
    function loop(){cx+=(tx-cx)*.18;cy+=(ty-cy)*.18;dr.style.transform='translate3d('+cx.toFixed(1)+'px,'+cy.toFixed(1)+'px,0)';requestAnimationFrame(loop)}
  }
})();
